/**
 * 合作伙伴查询
 */
import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class PartnerController<T = any> extends BasesController<T> {
  Model = new BaseModel({ type: 'object' });

  /** 合作伙伴数据 */
  get partnerData(): Array<any> {
    return lodash.get(this.Model.value, 'partnerData', []);
  }

  /** 渠道商类别身份解释 写死的数据 */
  get explainInfo() {
    return [
      {
        channelType: '全国总代理',
        purchaseRoute: '从联想直接进货',
        bu: 'ISG',
        id: 1,
      },
      {
        channelType: '垫资商',
        purchaseRoute: '从联想直接进货',
        bu: 'ISG',
        id: 2,
      },
      {
        channelType: '解决方案战略伙伴',
        purchaseRoute: '从联想直接进货',
        bu: 'ISG',
        id: 3,
      },
      {
        channelType: '政企服务商',
        purchaseRoute: '从联想直接进货',
        bu: 'ISG/REL',
        id: 4,
      },
      {
        channelType: '政企增值代理商',
        purchaseRoute: '从联想直接进货',
        bu: 'ISG/REL',
        id: 5,
      },
      {
        channelType: '服务经销商',
        purchaseRoute: '从联想直接进货',
        bu: 'ISG/SSG',
        id: 6,
      },
      {
        channelType: '政企增值经销商',
        purchaseRoute: '从服务商或者总代处进货',
        bu: 'ISG/REL',
        id: 7,
      },
      {
        channelType: 'SMB增值经销商',
        purchaseRoute: '从服务商或者总代处进货',
        bu: 'SMB',
        id: 8,
      },
    ];
  }

  /**
   * @ 查询合作伙伴信息
   */
  async getSearchData(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.content_coop_search,
        body,
      });
      console.log('～～zy～～ ~ res', res);
      // const partnerData = [
      //   { bu: 'ISG', companyName: '北京xxx公司', city: '北京', id: 1 },
      //   { bu: 'REL', companyName: '北京xxx公司', city: '北京', id: 2 },
      //   { bu: 'ISG', companyName: '北京xxx公司', city: '北京', id: 3 },
      //   { bu: 'REL', companyName: '北京xxx公司', city: '北京', id: 4 },
      // ];
      this.Model.merge({ partnerData: res });
    } catch (error) {}
  }
}
